export default {
      id: "i-warning-circle-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-warning-circle",
      toString: function () {
        return this.url;
      }
    }